export default __webpack_public_path__ + "static/media/service3.48e15d2a.svg";